export default "__VITE_ASSET__caa0e19b__"